export default __webpack_public_path__ + "static/media/court_logo.07451ab0.png";